// =============================================================================
// Pdf Utilities
// =============================================================================

import type { Maybe } from '@adornis/base/utilTypes.js';
import { DateTime } from 'luxon';
import { ILSFile } from '../db/ils-files.js';

const makeDateTime = (date: Date | DateTime) => {
  if (DateTime.isDateTime(date)) return date;
  return DateTime.fromJSDate(date);
};

function _getUserFullName(user: { ecommerce?: Maybe<{ firstName: string; lastName: string }> }) {
  if (user.ecommerce?.firstName && user.ecommerce.lastName)
    return `${user.ecommerce.firstName} ${user.ecommerce.lastName}`.replace(/\s+/g, '_');
  return '';
}

export function generateResultPdfFileName(
  user: { ecommerce?: Maybe<{ firstName: string; lastName: string }> },
  examDay: { end: Date | DateTime },
): string {
  const userName: string = _getUserFullName(user);
  const examDayStr: string = makeDateTime(examDay.end).toLocaleString();

  return encodeURIComponent(`Ergebnis_${userName}_${examDayStr}.pdf`);
}

export function generateRecreateInvoicePdfFileName(
  order: { invoiceNumber: Maybe<string> },
  invoiceID?: string,
): string {
  if (!order.invoiceNumber) throw new Error('order has no invoiceNumber');
  return `${ILSFile.getServeLink(invoiceID as string)}/${order.invoiceNumber}.pdf`;
}

export function generateInvoicePdfFileName(order: { invoiceNumber: Maybe<string> }, invoiceID: string): string {
  if (!order.invoiceNumber) throw new Error('order has no invoiceNumber');
  return `${ILSFile.getServeLink(invoiceID)}/${order.invoiceNumber}.pdf`;
}

export function generateCertificatePdfFileName(user: { ecommerce?: Maybe<{ firstName: string; lastName: string }> }) {
  const userName: string = _getUserFullName(user);

  return encodeURIComponent(`FaMed_Urkunde_${userName}.pdf`);
}

export function generateParticipantsPdfFileName(dayStart: Date | DateTime): string {
  return `teilnehmerliste_${makeDateTime(dayStart).toFormat('yyyyMMdd')}.pdf`;
}

// todo: dynamically get url host and controller name
export function generatePdfUrl(order: { _id: string }, action: string): string {
  if (typeof window === 'undefined') {
    // if node
    return `http://localhost:3000/__print/print-${action}?${new URLSearchParams({ order: order._id }).toString()}`;
  } else {
    return `http://localhost:3000/__print/print-${action}?order=${order._id}`;
  }
}
